// extracted by mini-css-extract-plugin
export default {"footerContainer":"spotWalletFooter_footerContainer__sL-5T"};